// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsGeneralForm__wrapper__v2fvv","submitResult":"SettingsGeneralForm__submitResult__O86PN","actionWrapper":"SettingsGeneralForm__actionWrapper__1AFX1","wrapper2faOptions":"SettingsGeneralForm__wrapper2faOptions__1cSug"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsGeneralForm/SettingsGeneralForm.css
// module id = 3006
// module chunks = 0